import {FETCH_BROADCAST_LIST } from "../actionTypes"
import { fetchBroadcastList } from "../../../api/broadcast/getbroadcastList.service"

const Request = ()=>({type: FETCH_BROADCAST_LIST.REQUEST})
const Failure = (error)=>({type: FETCH_BROADCAST_LIST.FAILURE, error})
const Success = (obj)=>({type: FETCH_BROADCAST_LIST.SUCCESS, obj})


export const getBroadcastList = (next=null,status,orderBy)=>{

    return (dispatch, getState)=>{        
        dispatch(Request())
        return fetchBroadcastList(next,status,orderBy)
        .then(response => {         
            let obj={
                'data':response.data,
                'next':response.next,
                "isLoadMore": next?true:false,
                'statusCount':response?.statusCount
            }    
            dispatch(Success(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(Failure(error?.message))
            return Promise.resolve(false)
        })
    }
}